import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading5, ArticleParagraph2 } from '@cian/ui-kit/typography';
import { ILocation } from '../../../../../../../types/location';

export interface ISuggestProps {
  suggest: ILocation[];
  onItemClick(value: ILocation): void;
}

export function Suggest({ suggest, onItemClick }: ISuggestProps) {
  return (
    <div className={styles['suggest']} data-testid="suggest-popup">
      {suggest.map(item => {
        const onClick = () => onItemClick(item);

        return (
          <div key={item.id} className={styles['suggest-item']} onClick={onClick} data-testid="item">
            <ArticleParagraph2>{item.displayName}</ArticleParagraph2>
          </div>
        );
      })}
      {!suggest.length && (
        <div className={styles['suggest-error']} data-testid="error">
          <ArticleHeading5>Ничего не найдено</ArticleHeading5>
          <ArticleParagraph2>Укажите другой регион</ArticleParagraph2>
        </div>
      )}
    </div>
  );
}
